/*==========================================================
iCREATE MODE DETECTION SCRIPT
==========================================================*/

//front-end development vs. iCreate development
var isFrontEndDev = false;
var devLocation = location.hostname;
if (devLocation == "localhost" || devLocation == "127.0.0.1" || devLocation == "preview.esolutionsgroup.ca") {
    isFrontEndDev = true;
}

$(function() {
    //Set Uber classes to target iCreate modes
    //public mode
    // if (!iCreateObject.isSiteInICreateMode && !iCreateObject.isSiteInPreviewMode){
    //     $('#uber').addClass('public-mode');
    // }

    //public mode or preview mode
    // if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode){
    //     $('#uber').addClass('public-preview-mode');
    // }

    //public mode or edit mode
    // if (!iCreateObject.isSiteInICreateMode || !iCreateObject.isSiteInPreviewMode){
    //     $('#uber').addClass('public-edit-mode');
    // }

    //preview mode
    // if (iCreateObject.isSiteInPreviewMode){
    //     $('#uber').addClass('preview-mode');
    // }

    //preview mode or edit mode
    if (iCreateObject.isSiteInICreateMode) {
        $('#uber').addClass('preview-edit-mode');
    }

    //edit mode
    if (iCreateObject.isSiteInICreateMode && !iCreateObject.isSiteInPreviewMode) {
        $('#uber').addClass('edit-mode');
    }

    //compare mode
    if (iCreateObject.isSiteInICreateMode && iCreateObject.isiCreateGeneratedPage) {
        $('#uber,#uberMain,html').addClass('compare-mode');
    }
});